<template>
    <div class="qclist">
        <div>
            <van-nav-bar
                class="restclass"
                title="维修派工"
                left-text="返回"
                left-arrow
                @click-left="getBack" />
        </div>

        <div class="clientList">
            <van-row class="search">
                <van-col span="18"><van-search v-model="parameter.searchKey" placeholder="请输入搜索关键词" class="search" /></van-col>
                <van-col span="2">
                    <van-button type="primary" size="normal" round style="font-size:13px;margin-top:10px;"
                        @click="search">查&nbsp;询</van-button>
                </van-col>
                <van-col span="2" style="float:right; margin:5px 0 0 15px;">
                    <van-icon name="scan" size="30" round title="扫一扫"
                        @click="scan" />
                </van-col>
            </van-row>
            <van-row style="margin:5px">
                <van-col span="4"><van-button type="primary" size="normal" round style="font-size:10px;"
                    @click="searchAll">全部</van-button></van-col>
                <van-col span="20">
                    <van-dropdown-menu active-color="#ee0a24">
                        <van-dropdown-item v-model="value1" :options="option1" />
                        <van-dropdown-item v-model="value2" :options="option2" />
                        <van-dropdown-item v-model="value3" :options="option3" />
                    </van-dropdown-menu>
                </van-col>
            </van-row>
            <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
                <van-list v-model="loading"
                    :finished="finished"
                    :finished-text="finishedText" @load="onLoad">
                    <div
                        v-for="(item,index) in list"
                        :key="item.Id"
                        class="list clearfix">
                        <div class="clearfix">
                            <van-row>
                                <van-col span="3"><van-tag type="success" size="large" style="margin: 5px">{{ index + 1 }}</van-tag></van-col>
                                <van-col span="18">
                                    <p>
                                        <span class="info-span">{{ item.driver }}</span>
                                        <span class="info-span">{{ item.sheetNo }}</span>
                                    </p>
                                    <p>
                                        <span class="info-span">{{ item.teamNames }}</span>
                                        <span class="info-span">{{ item.category + '-' + item.vehicleCode + '-' + item.barCode }}</span>
                                    </p>
                                    <p>
                                        <span class="info-span">{{ item.commitTime | parsetime }}</span>
                                        <span :style="`color:${filterstatuss(item.enumWorkOrderStatus)}`" class="info-span">{{ convertStatus(item.enumWorkOrderStatus) }}</span>
                                    </p>
                                </van-col>
                                <van-col v-if="$_has('maintain:qualitycheck:edit')" span="3" @click="onDetailClick(item.id)"><van-button type="primary" round>质检</van-button></van-col>
                            </van-row>
                        </div>
                    </div>
                </van-list>
            </van-pull-refresh>

            <p v-if="list.length === 0" class="noList">暂无数据</p>
        </div>
        <bottom />
    </div>
</template>

<script>

import bottom from '@/components/bottom'
import { getQualityCheckList } from '@/api/maintain'
import { getcategory, queryTeamList } from '@/api/basics'

export default {
    name: 'QualityCheckList',
    components: {
        bottom
    },
    filters: {
        parsetime(date1) {
            var date = new Date(date1)
            var month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
            var currentDate = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
            return date.getFullYear() + '-' + month + '-' + currentDate
        }
    },
    data() {
        return {
            finishedText: '已加载全部',
            refreshing: false,
            loading: false,
            finished: false,
            parameter: {
                searchKey: '',
                enumWorkOrderStatus: [],
                category: '',
                pageIndex: 1, // 当前页
                pageSize: 10 // 每页多少条
            },
            list: [],
            value1: 0,
            value2: '',
            value3: '',
            option1: [
                { text: '按状态', value: 0 },
                { text: '维修中', value: 3 },
                { text: '维修中-领料完成', value: 4 },
                { text: '维修中-质检不通过', value: 5 }
            ],
            option2: [],
            option3: []
        }
    },
    created() {
        this.initCategory()
        this.queryTeamLists()
    },
    mounted() {
        window['scanit'] = data => {
            this.scanit(data)
        }
    },
    methods: {
        getBack() {
            this.$router.push({ path: '/' })
        },
        scan() {
            window.test.ToScan()
        },
        async scanit(val) {
            this.loading = true
            // this.payload.barCode = val
            this.parameter.pageIndex = 1
            this.parameter.barCode = val
            const response = await getQualityCheckList(this.parameter)
            if (response.isSuccess) {
                this.loading = false
                this.list = response.data.pagerData
                this.totalCount = response.data.totalCount
            }
        },
        queryTeamLists() {
            const param = {
                PageIndex: 1,
                PageSize: 10000,
                captain: '',
                teamCode: ''
            }
            queryTeamList(param)
                .then((res) => {
                    if (res.code == 200) {
                        var data = res.data.pagerData
                        this.option3 = [{ text: '按维修队', value: '' }]
                        var i = 0
                        for (i; i < data.length; i++) {
                            var item = {}
                            item.text = data[i].teamName
                            item.value = data[i].teamName
                            this.option3[i + 1] = item
                        }
                    }
                })
        },
        initCategory() {
            getcategory()
                .then((res) => {
                    if (res.code == 200) {
                        var data = res.data
                        this.option2 = [{ text: '按类别', value: '' }]
                        var i = 0
                        for (i; i < data.length; i++) {
                            var item = {}
                            item.text = data[i].content
                            item.value = data[i].content
                            this.option2[i + 1] = item
                        }
                    }
                })
        },
        onLoad() {
            this.loading = true
            if (this.refreshing) {
                this.parameter.pageIndex = 1
                this.list = []
            }
            if (this.value1 != 0) {
                this.parameter.enumWorkOrderStatus = [this.value1]
            }
            this.parameter.category = this.value2
            this.parameter.teamName = this.value3
            getQualityCheckList(this.parameter)
                .then((res) => {
                    if (res.code == 200) {
                        this.parameter.pageIndex === 1 ? this.list = res.data.pagerData : this.list = this.list.concat(res.data.pagerData)
                        // 判读是否加载到最后一页
                        this.list.length >= res.data.totalCount ? this.finished = true : this.parameter.pageIndex++
                        this.list.length === 0 ? this.finishedText = '' : this.finishedText = '已加载全部'
                        // 请求完毕后隐藏正在 加载样式
                        this.loading = false
                        this.refreshing = false
                    }
                })
        },
        onRefresh() {
            this.finished = false
            this.onLoad()
        },
        search() {
            this.refreshing = true
            this.onLoad()
        },
        searchAll() {
            this.parameter.enumWorkOrderStatus = []
            this.parameter.category = ''
            this.parameter.searchKey = ''
            this.value1 = 0
            this.value2 = ''
            this.value3 = ''
            this.parameter.barCode = ''
            this.refreshing = true
            this.onLoad()
        },
        filterstatuss(str) {
            const obj = {
                3: 'blue',
                4: 'green',
                5: 'red'
            }
            return obj[str]
        },
        convertStatus(status) {
            switch (status) {
            case 3:
                return '维修中'
            case 4:
                return '维修中-领料完成'
            case 5:
                return '维修中-质检不通过'
            }
        },
        onDetailClick(id) {
            this.$router.push({
                path: '/QualityCheckDetail',
                query: {
                    id: id
                }
            })
        }
    }
}
</script>

<style lang='scss' scoped>
.qclist{
    width: 100%;
  .clientList{
    margin-bottom: 100px;
    padding: 0px 40px;
    h2{
      font-size: 32px;
      font-weight: 700;
      margin-bottom: 25px;
    }
    .search{
      margin:8px 0;
      button{
        width: 100px;
        height: 50px;
        color: #ffffff;
        margin-left: 10px;
        border-radius: 10px;
      }
    }
    .list{
      padding: 20px 0;
      border-bottom: 1px solid #ccc;
      h3{
        font-size: 38px;
        font-weight: 700;
      }
      .msg{
        padding: 20px 0;
        font-size: 18px;
        .phone{
          margin-left: 10%;
          color: #3498db;
        }
      }
      p{
        color: #999;
        font-size: 20px;
        padding: 5px 0;
      }
    }
  }
}
.info-span{
    display:inline-block;
    padding: 2px;
    color:#000;
    width:45%;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
}
.info-span-red{
    padding:0px 8px;
    color:#f00;
}
.info-span-blue{
    color: #3498db;
}
</style>

<style lang='scss' scoped>
.nav{
  width: 100%;
  padding: 20px 0px;
  background: #3498ff;
  color: #fff;
  .nav-title{
    width: 100%;
    font-size: 30px;
    text-align: center;
    display: block;
  }
}
.noList{
  text-align: center;
  margin-top: 50%;
  font-size: 26px;
  color: #ccc;
}
.van-dialog{
  width: 70%;
  height: 15%;
  .van-dialog__content{
    height: 65%;
    padding-top: 5%;
    text-align: center;
    .van-dialog__message{
      text-align: center;
      font-size: 26px;
    }
  }
  .van-dialog__footer--buttons{
    height: 35%;
    .van-button{
      width: 50%;
      height: 100%;
      .van-button__text{
        font-size: 26px;
      }
    }
  }
}
</style>
